export default "__VITE_ASSET__CHUE_sgp__"